import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    startAddNewBlog,
    startDeleteBlog,
    startGetAllBlogs
} from '../../actions/blog';
import {
    Button,
    Header,
    Modal,
    Form,
    List,
    Grid,
    Search,
    Dropdown,
    Message
} from 'semantic-ui-react';
import _ from 'lodash';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

const options = [
    { key: 'en', text: 'English', value: 'en', flag: 'gb' },
    { key: 'ro', text: 'Romanian', value: 'ro', flag: 'ro' }
];

class BlogManagement extends Component {
    componentDidMount() {
        this.props.startGetAllBlogs();
        this.resetComponent();
    }

    state = {
        openAddNewModal: false,
        options: options,
        openDeleteModal: false,
        listOfBlogs: [],
        author: '',
        content: '',
        comments: [],
        date: '',
        summary: '',
        language: '',
        title: '',
        isLoading: false,
        results: [],
        value: '',
        selectedFile: null,
        fileErrorText: '',
        fileError: false
    };
    showAddNewModal = () => this.setState({ openAddNewModal: true });
    closeAddNewModal = () => this.setState({ openAddNewModal: false });
    showDeleteModal = () => this.setState({ openDeleteModal: true });
    closeDeleteModal = () => this.setState({ openDeleteModal: false });
    handleChange = (e, { name, value }) => this.setState({ [name]: value });

    fileChangedHandler = event => {
        const fileExtension = event.target.files[0].name.split('.').pop();
        const reader = new FileReader();
        const file = event.target.files[0];
        if (
            !(
                fileExtension.toLowerCase() === 'jpg' ||
                fileExtension.toLowerCase() === 'jpeg' ||
                fileExtension.toLowerCase() === 'png'
            )
        ) {
            this.setState({
                fileError: true,
                fileErrorText:
                    'Only jpg, jpeg and png file formats are accepted!'
            });
            console.log('Only jpg, jpeg and png file formats are accepted!');
        } else if (event.target.files[0].size > 2000000) {
            this.setState({
                fileError: true,
                fileErrorText: 'The maximum file size is 2 MB!'
            });
            console.log('The maximum file size is 2 MB!');
        } else if (event.target.files && event.target.files.length > 0) {
            this.setState({
                fileError: false
            });
            reader.readAsDataURL(file);
            reader.onload = () => {
                console.log(reader.result.split(',')[1]);
                this.setState({ selectedFile: reader.result.split(',')[1] });
            };
        }
    };

    handleSubmit = () => {
        const {
            author,
            content,
            date,
            summary,
            title,
            language,
            selectedFile
        } = this.state;
        const blog = {
            author: author,
            content: content,
            date: date,
            summary: summary,
            comments: '',
            title: title,
            language: language,
            votes: 0,
            deleted: false,
            selectedFile: selectedFile
        };
        this.props.startAddNewBlog(blog);
        this.setState({
            author: '',
            content: '',
            comments: '',
            date: '',
            summary: '',
            language: '',
            title: '',
            open: false,
            selectedFile: null,
            fileError: false,
            fileErrorText: ''
        });
    };

    onDeleteBlog = (id, e) => {
        e.preventDefault();
        this.props.startDeleteBlog(id);
        this.resetComponent();
    };

    resetComponent = () =>
        this.setState({ isLoading: false, results: [], value: '' });

    handleResultSelect = (e, { result }) => {
        this.setState({ value: result.title });
    };

    handleSearchChange = (e, { value }) => {
        this.setState({ isLoading: true, value });

        setTimeout(() => {
            if (this.state.value.length < 1) return this.resetComponent();

            const re = new RegExp(_.escapeRegExp(this.state.value), 'i');
            const isMatch = result => re.test(result.title);
            this.setState({
                isLoading: false,
                results: _.filter(this.props.blogs, isMatch)
            });
        }, 300);
    };
    render() {
        const {
            author,
            content,
            date,
            summary,
            language,
            title,
            fileError,
            fileErrorText
        } = this.state;
        const { isLoading, value, results } = this.state;
        return (
            <div>
                <Button onClick={this.showAddNewModal}>Add New Blog</Button>
                <Modal
                    dimmer="blurring"
                    style={inlineStyle.modal}
                    open={this.state.openAddNewModal}
                    onClose={this.closeAddNewModal}
                >
                    <Modal.Header>Add New Blog</Modal.Header>
                    <Modal.Content>
                        <Form onSubmit={this.handleSubmit} warning={fileError}>
                            <Form.Group>
                                <Form.Input
                                    label="Blog title"
                                    placeholder="Title"
                                    name="title"
                                    value={title}
                                    onChange={this.handleChange}
                                    width={8}
                                    required
                                />
                                <Form.Input
                                    label="Blog author"
                                    placeholder="Author"
                                    name="author"
                                    value={author}
                                    onChange={this.handleChange}
                                    width={8}
                                    required
                                />
                            </Form.Group>
                            <Form.Input
                                label="Blog summary"
                                placeholder="Summary"
                                name="summary"
                                value={summary}
                                onChange={this.handleChange}
                                required
                            />
                            <Form.TextArea
                                label="Blog content"
                                placeholder="Content"
                                name="content"
                                value={content}
                                onChange={this.handleChange}
                                required
                            />
                            <Form.Field>
                                <DayPickerInput
                                    onDayChange={day =>
                                        this.setState({ date: day })
                                    }
                                    value={date}
                                    placeholder="Please select a date"
                                />
                            </Form.Field>
                            <Form.Field>
                                <input
                                    type="file"
                                    onChange={this.fileChangedHandler}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Dropdown
                                    button
                                    className="icon"
                                    floating
                                    labeled
                                    icon="world"
                                    selection
                                    name="language"
                                    options={this.state.options}
                                    value={language}
                                    placeholder="Please pick a language"
                                    onChange={this.handleChange}
                                    required
                                />
                            </Form.Field>
                            <Message
                                warning
                                header="File error"
                                content={fileErrorText}
                            />
                            <Form.Button content="Submit" />
                        </Form>
                    </Modal.Content>
                </Modal>
                <Button onClick={this.showDeleteModal}>Delete Blog</Button>
                <Modal
                    dimmer="blurring"
                    style={inlineStyle.modal}
                    open={this.state.openDeleteModal}
                    onClose={this.closeDeleteModal}
                >
                    <Modal.Header>
                        Delete Blog
                        <Grid>
                            <Grid.Column width={8}>
                                <Search
                                    loading={isLoading}
                                    onResultSelect={this.handleResultSelect}
                                    onSearchChange={_.debounce(
                                        this.handleSearchChange,
                                        500,
                                        { leading: true }
                                    )}
                                    results={results}
                                    value={value}
                                />
                            </Grid.Column>
                        </Grid>
                    </Modal.Header>
                    <Modal.Content>
                        <div>
                            <List divided verticalAlign="middle">
                                {results.length === 0
                                    ? this.props.blogs.map(
                                          blog =>
                                              blog.deleted === false ? (
                                                  <List.Item key={blog.id}>
                                                      <List.Content floated="right">
                                                          <Button
                                                              onClick={e =>
                                                                  this.onDeleteBlog(
                                                                      blog.id,
                                                                      e
                                                                  )
                                                              }
                                                          >
                                                              Delete
                                                          </Button>
                                                      </List.Content>
                                                      <List.Content>
                                                          {blog.title}
                                                      </List.Content>
                                                  </List.Item>
                                              ) : (
                                                  ''
                                              )
                                      )
                                    : results.map(
                                          blog =>
                                              blog.deleted === false ? (
                                                  <List.Item key={blog.id}>
                                                      <List.Content floated="right">
                                                          <Button
                                                              onClick={e =>
                                                                  this.onDeleteBlog(
                                                                      blog.id,
                                                                      e
                                                                  )
                                                              }
                                                          >
                                                              Delete
                                                          </Button>
                                                      </List.Content>
                                                      <List.Content>
                                                          {blog.title}
                                                      </List.Content>
                                                  </List.Item>
                                              ) : (
                                                  ''
                                              )
                                      )}
                            </List>
                        </div>
                    </Modal.Content>
                </Modal>
            </div>
        );
    }
}
const inlineStyle = {
    modal: {
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
};

function mapStateToProps(state) {
    return {
        blogs: state.blogReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        startAddNewBlog: blog => dispatch(startAddNewBlog(blog)),
        startDeleteBlog: id => dispatch(startDeleteBlog(id)),
        startGetAllBlogs: () => dispatch(startGetAllBlogs())
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BlogManagement);



// WEBPACK FOOTER //
// ./src/components/Blog/BlogManagement.js